import { load_model } from './model-cache'
import { center_model, fit_model_camera } from './model-framing'

const thumbnails = new Map();
let queue = Promise.resolve();

// Render once per URL, sequentially, so long event lists cannot exhaust WebGL contexts.
export function load_model_thumbnail(url){
    if(!thumbnails.has(url)){
        const thumbnail = queue.then(() => render_thumbnail(url));
        queue = thumbnail.catch(() => {});
        thumbnails.set(url, thumbnail);
        thumbnail.catch(() => thumbnails.delete(url));
    }
    return thumbnails.get(url);
}

async function render_thumbnail(url){
    const { THREE, gltf } = await load_model(url);
    const materials = [];
    let renderer;
    try{
        const model = gltf.scene.clone(true);
        model.traverse((node) => {
            if(!node.isMesh || !node.material) return;
            const clone = (material) => {
                const copy = material.clone();
                copy.side = THREE.DoubleSide;
                materials.push(copy);
                return copy;
            };
            node.material = Array.isArray(node.material) ? node.material.map(clone) : clone(node.material);
        });
        const pivot = center_model(THREE, model);
        const scene = new THREE.Scene();
        scene.add(pivot);
        scene.add(new THREE.AmbientLight(0xffffff, 0.7));
        const key = new THREE.DirectionalLight(0xffffff, 0.9);
        key.position.set(2, 3, 4);
        scene.add(key);
        const fill = new THREE.DirectionalLight(0xffffff, 0.4);
        fill.position.set(-3, 1, -2);
        scene.add(fill);
        const camera = new THREE.PerspectiveCamera(35, 1, 0.1, 100);
        fit_model_camera(camera);
        renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
        renderer.setSize(160, 160);
        renderer.render(scene, camera);
        return renderer.domElement.toDataURL('image/png');
    } finally {
        materials.forEach(material => material.dispose());
        if(renderer){
            renderer.dispose();
            renderer.forceContextLoss();
        }
    }
}
